import * as React from 'react';
import { Rating, Typography } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { isRatingValueValid, isNumberOfRatingsValid } from 'utils/domain-specifics/reviews/validation';
import * as styles from './overall-rating-block.styles';
import { secondRow } from './overall-rating-block.styles';

export type OverallRatingBlockProps = {
  numberOfRatings: number;
  ratingValue: number;
} & React.HTMLAttributes<HTMLElement>;

const precision = 1;
const locale = 'ru-RU';

const formatRatingValue = Intl.NumberFormat(locale, {
  minimumFractionDigits: precision,
  maximumFractionDigits: precision,
});

export const OverallRatingBlock: React.FC<OverallRatingBlockProps> = ({
  ratingValue,
  numberOfRatings,
  className = '',
  ...htmlProps
}) => {
  const { t } = useTranslation();
  return (
    <div className={className} {...htmlProps}>
      <div className={styles.firstRow}>
        {isRatingValueValid(ratingValue) ? (
          <>
            <div data-testid="rating-full-title-pdp">
              <Typography variant="h1" color="text-primary">
                {formatRatingValue.format(ratingValue)}
              </Typography>
            </div>
            <div className={styles.ratingWrapper} data-testid="rating-stars-pdp">
              <Rating value={ratingValue} color="text-primary" />
            </div>
          </>
        ) : null}
      </div>
      {isNumberOfRatingsValid(numberOfRatings) ? (
        <div className={secondRow} data-testid="rating-subtitle-pdp">
          <Typography variant="s" size="body_long" color="text-primary">
            {t('reviews.review.based-on')} {numberOfRatings}&nbsp;
            {t('reviews.review.review-count.count', { count: Number(numberOfRatings) })}
          </Typography>
        </div>
      ) : null}
    </div>
  );
};
